module.exports = __webpack_public_path__ + "img/nav-about@2x.57f8dd8.jpg";